import {AnyAction} from 'redux';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {ISmartEngageData} from './types';
import {AppState} from '../../../../verticals/hotels-dweb/src/shared/store';
import {toggleLoadingSmartEngageAction, updateSmartEngageDataAction} from './actions';
import {smartEngageBannerListApi} from '@stencil/hotels-smartengage-apis';
import {parseDateIntoHermesString} from '@stencil/hotels-utils/src/date-utils/date-utils';
import roomStringUtils from '@stencil/hotels-utils/src/room-string-utils';
import {trackApiFailureDweb} from '@stencil/hotels-utils/src/track-api-failure';

export const fetchSmartEngageDataThunk = (
  config = null,
  withParams = false,
): ThunkAction<void, AppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<AppState, {}, AnyAction>, getState: () => AppState) => {
    dispatch(toggleLoadingSmartEngageAction(true));
    let params = {};
    const {common} = getState();
    const {destination, checkin, checkout, roomString} = common;
    const {_id: city_id = ''} = destination;
    const {sendNodeId, slots} = config;
    if (city_id) params = (sendNodeId && {node_id: city_id}) || {city_id};

    if (withParams) {
      const {roomCount, paxCount, childCount} = roomStringUtils.splitRoomString(roomString);
      params = {
        ...params,
        checkin_date: parseDateIntoHermesString(checkin.date),
        checkout_date: parseDateIntoHermesString(checkout.date),
        pax_adult: paxCount,
        pax_child: childCount,
        pax_room: roomCount,
      };
    }

    smartEngageBannerListApi({params, config})
      .then((response: ISmartEngageData) => {
        if (response.data && response.success && response.data && response.data.slots) {
          let filteredSlots = {};
          Object.keys(response.data.slots)
            .filter(item => slots.indexOf(item) !== -1)
            .map(key => {
              filteredSlots = {...filteredSlots, [key]: response.data.slots[key]};
            });
          dispatch(updateSmartEngageDataAction({slots: filteredSlots} as ISmartEngageData['data']));
        }
        dispatch(toggleLoadingSmartEngageAction(false));
      })
      .catch(err => {
        // ! do something for error case
        console.error(err);
        trackApiFailureDweb({apiName: 'smartengage', error: err});
        dispatch(toggleLoadingSmartEngageAction(false));
      });
    // }
  };
};
